export function isPathActive(pathname: string, href: string): boolean {
  const basePath = href.split("?")[0];

  return pathname === basePath || pathname.startsWith(basePath + "/");
}
